// extracted by mini-css-extract-plugin
export default {"page":"AdminProductList_page__ZnLoD","grid":"AdminProductList_grid__mZXkt","newButton":"AdminProductList_newButton__twrVD","newButtonExtra":"AdminProductList_newButtonExtra__IR46o"};